import * as _ from 'lodash';

export abstract class BaseEnum {

  public toArray(value_key: string = 'value', label_key: string = 'label'): Array<EnumeratorData> {
    const enum_array = [];
    _.forEach(this.enumerators, (enum_data, enum_key) => {
      const data = {};
      _.set(data, label_key, enum_data[1]);
      _.set(data, value_key, enum_data[0]);
      enum_array.push(data);
    });
    return enum_array;
  }

  public getKeys(): Array<string> {
    const keys = [];
    _.forEach(this.enumerators, (enum_data, enum_key) => {
      keys.push(enum_key);
    });
    return keys;
  }

  public getValues(): Array<number> {
    const values = [];
    _.forEach(this.enumerators, (enum_data, enum_key) => {
      values.push(enum_data[0]);
    });
    return values;
  }

  public humanize(value): string {
    let humanized = '';
    _.forEach(this.enumerators, (enum_data, enum_key) => {
      if (enum_data[0] == value) {
        humanized = enum_data[1];
      }
    });
    return humanized;
  }

  constructor(private enumerators) {
    for (const enumerator_key in this.enumerators) {
      this[enumerator_key] = this.enumerators[enumerator_key][0];
      this[this.enumerators[enumerator_key][0]] = enumerator_key;
    }
  }
}

export interface EnumeratorData {
  label: string;
  value: number;
}
